<template>
  <div style="height: auto;width: 100%;margin-top: 5px;" class="cargo-advance-search fcl-search-bar">
    <div v-show="showSimple" class="cargo-advance-search-header">
      <div class="cargo-advance-search-toggle-trigger">
        <i
          v-show="showAdv"
          class="el-icon-arrow-left"
          :style="{transform: !isShowingMoreSearchCondition?'rotate(-90deg)':'rotate(90deg)'}"
          @click="upOrDownSearchCondition"
        />
      </div>
      <div v-show="showSimple && !isShowingMoreSearchCondition" class="cargo-advance-search-quick">
        <!--清空时不需要弹出提示，只有输入框为空，点击查询时才需要弹出提示-->
        <!--@clear="simSearch"-->
        <el-input
          v-if="showPriceNo"
          ref="keyword"
          v-model="keyWords"
          style="width:200px;"
          :placeholder="simQueryPlaceholder"
          :spellcheck="false"
          @blur="keyWordBlur"
          @keyup.enter.native.prevent="toQuery"
        />
        <cargo-advance-select
          v-if="!isShowingMoreSearchCondition && showPriceNo"
          style="width: 115px;display: inline-block;"
          filterable
          :disabled="disabled"
          :clearable="false"
          :select-type="selectTypeNames.basic_data_Currency"
          :default-value="filter.currency"
          @parentCallBack="changeCurrency"
        />
        <cargo-advance-select
          v-if="!isShowingMoreSearchCondition && !showPriceNo"
          ref="simPol"
          filterable
          :placeholder="$t('Pricing.POLPrompt')"
          :select-type="selectTypeNames.basic_data_Seaport"
          :custom-label="(item)=>`[${item.code}]${item.englishName}`"
          :filter-tag-names="['code','englishName']"
          :show-custom-label-in-option="true"
          style="width:190px;display: inline-block;margin-left: 10px;"
          @parentCallBack="p=>{filter.simPol=p.value}"
        />
        <cargo-advance-select
          v-if="!isShowingMoreSearchCondition && !showPriceNo"
          ref="simPod"
          filterable
          :placeholder="$t('Pricing.PODPrompt')"
          :select-type="selectTypeNames.basic_data_Seaport"
          :custom-label="(item)=>`[${item.code}]${item.englishName}`"
          :filter-tag-names="['code','englishName']"
          :show-custom-label-in-option="true"
          style="width:190px;display: inline-block;margin-left: 10px;"
          @parentCallBack="p=>{filter.simPod=p.value}"
        />
        <el-select
          v-if="!isShowingMoreSearchCondition && showLevel"
          v-model="filter.level"
          style="width:90px;display: inline-block;margin-left: 10px;"
          @change="onLevelChanged"
        >
          <el-option
            v-for="(item,index) in tiers"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div ref="searchOperations" class="cargo-advance-search-operations">
        <el-button style="margin-left: 10px" type="primary" :disabled="disabled" @click="toQuery">
          {{ $t('CargoMsg.Cargo_Query') }}
        </el-button>
        <el-button type="primary" @click="resetSearch()">{{ $t('CargoMsg.Cargo_Reset') }}</el-button>
        <slot name="operations">
          <!--页面操作按钮-->
        </slot>
      </div>
    </div>
    <slot name="searchAreaHeader">
      <!--搜索条件区域-头-->
    </slot>
    <div
      v-if="showAdv"
      v-show="isShowingMoreSearchCondition"
      class="section cargo-advance-search-more"
    >
      <div class="cargo-advance-search-more-operations" />
      <el-form
        ref="hbDetail"
        label-position="left"
        class="cargo-advance-search-form"
        label-width="75px"
        style="min-width: 830px;margin-right: 10px"
        :inline="true"
      >
        <el-radio-group v-model="rdoGroupOrg">
          <el-radio label="pol">{{ $t('Pricing.POL') }}</el-radio>
          <el-radio label="pols">{{ $t('Pricing.POLs') }}</el-radio>
          <el-radio label="col">{{ $t('Pricing.COL') }}</el-radio>
          <el-radio label="rol">{{ $t('Pricing.ROL') }}</el-radio>
          <el-radio label="polCityCode">{{ $t('Pricing.POLCity') }}</el-radio>
        </el-radio-group>
        <cargo-pop-select-input
          v-if="rdoGroupOrg === 'pols'"
          v-model="filter.pols"
          style="width:190px;display: inline-block;margin-left: 10px;"
          :column-defs="popSelectInputCols"
        />
        <cargo-advance-select
          v-if="rdoGroupOrg === 'pol'"
          filterable
          :placeholder="$t('Pricing.POLPrompt')"
          :select-type="selectTypeNames.basic_data_Seaport"
          :custom-label="(item)=>`[${item.code}]${item.englishName}`"
          :filter-tag-names="['code','englishName']"
          :show-custom-label-in-option="true"
          style="width:190px;display: inline-block;margin-left: 10px;"
          :default-value="filter.pol"
          @parentCallBack="p=>{filter.pol=p.value}"
        />
        <cargo-advance-select
          v-if="rdoGroupOrg === 'col'"
          filterable
          :placeholder="$t('Pricing.COLPrompt')"
          :select-type="selectTypeNames.basic_data_Country"
          style="width:190px;display: inline-block;margin-left: 10px;"
          @parentCallBack="p=>{filter.col=p.value}"
        />
        <cargo-advance-select
          v-if="rdoGroupOrg === 'rol'"
          filterable
          :select-type="selectTypeNames.basic_data_Region"
          :default-value="filter.rol"
          style="width:190px;display: inline-block;margin-left: 10px;"
          @parentCallBack="p=>{filter.rol=p.value}"
        />
        <cargo-advance-select
          v-if="rdoGroupOrg === 'polCityCode'"
          :static-options="citySeaport"
          tag-name="name"
          tag-value="code"
          clearable
          filterable
          :filter-tag-names="['name', 'code']"
          style="width:190px;display: inline-block;margin-left: 10px;"
          :default-value="filter.polCityCode"
          @parentCallBack="p=>{filter.polCityCode=p.value}"
        />
        <el-select
          v-model="filter.cmbCreatedBy"
          :disabled="isShowCreatedBy"
          style="width:100px;display: inline-block;margin-left: 10px;"
        >
          <el-option :label="$t('Pricing.CreatedBy')" value="createdBy" />
          <el-option :label="$t('Pricing.Branch')" value="branch" />
        </el-select>
        <cargo-advance-select
          v-if="filter.cmbCreatedBy === 'createdBy'"
          filterable
          :select-type="selectTypeNames.basic_data_User"
          :default-value="filter.createdBy"
          :callback-params="{key:'userId'}"
          style="width:190px;display: inline-block;margin-left: 10px;"
          @parentCallBack="p=>{filter.createdBy=p.value}"
        />
        <cargo-office-select
          v-if="filter.cmbCreatedBy === 'branch'"
          :disabled="false"
          :office-id="filter.branch"
          :default-value="filter.branch"
          style="width:190px;display: inline-block;margin-left: 10px;"
          @parentCallBack="p=>{filter.branch=p.value}"
        />
        <el-form-item v-if="isManageModule" ref="hbDateCreatedFromTo" :label="$t('Pricing.CreatedDate')" style="margin-left: 10px;">
          <el-date-picker
            v-model="filter.createDateFrom"
            type="date"
            style="width:130px;margin-left:10px"
            value-format="yyyy-MM-dd"
          />
          <span style="margin: 5px;">{{ $t('Pricing.EndDate') }}</span>
          <el-date-picker
            v-model="filter.createDateTo"
            type="date"
            style="width:130px;margin-left:10px"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item v-if="isShowSaleState" ref="hbSaleState" :label="$t('Pricing.SaleState')" style="margin-left: 10px;">
          <cargo-advance-select
            style="width: 115px;"
            filterable
            :disabled="disabled"
            :clearable="false"
            :default-value="filter.saleState"
            :headers="[$t('Message.Code')]"
            :fields="['code']"
            tag-name="chineseName"
            tag-value="code"
            :select-type="selectTypeNames.local_cache_SpecialPriceSaleState$SALE_STATE_TYPES_All"
            @parentCallBack="p=>{filter.saleState=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="isShowContractNo" ref="hbContractNo" :label="$t('Pricing.ContractNo')" style="margin-left: 10px;">
          <el-input v-model="filter.contractNo" style="width: 85px;" />
        </el-form-item>
        <el-form-item v-if="isSurcharge" ref="hbDangerous" :label="$t('Pricing.Dangerous')" style="margin-left: 10px;">
          <el-checkbox v-model="filter.dangerous" />
        </el-form-item>
        <el-form-item v-if="isSurcharge && !isQuery" ref="hbBookingAgent" :label="$t('Pricing.BookingAgent')" style="margin-left: 10px;">
          <cargo-advance-select
            filterable
            :select-type="selectTypeNames.basic_data_Company"
            :method-params="{bookingAgent:true}"
            :custom-label="(item)=>`${item.chineseName}`"
            :show-custom-label-in-option="true"
            style="width:190px;"
            tag-value="cmpIdx"
            @parentCallBack="p=>{filter.bAgentAutoComplete=p.cmpIdx}"
          />
        </el-form-item>
        <el-form-item v-if="isSurcharge && !isQuery" ref="hFeeName" :label="$t('Pricing.FeeName')" style="margin-left: 10px;">
          <cargo-advance-select
            filterable
            :select-type="selectTypeNames.basic_data_ChargeItem"
            callback-method-type="value"
            style="width:190px;"
            tag-name="zhName"
            tag-value="scaleCode"
            @parentCallBack="p=>{filter.chargeScaleCode=p}"
          />
        </el-form-item>
        <el-form-item v-if="showCurrency" ref="hbCurrency" :label="$t('Pricing.Currency')" style="margin-left: 10px;">
          <cargo-advance-select
            style="width: 115px;"
            filterable
            :disabled="disabled"
            :clearable="false"
            :default-value="filter.currency"
            :select-type="selectTypeNames.basic_data_Currency"
            @parentCallBack="changeCurrency"
          />
        </el-form-item>
      </el-form>
      <el-form ref="hbDetail2" label-width="80px" label-position="left" :inline="true">
        <el-radio-group v-model="rdoGroupDes">
          <el-radio label="pod">{{ $t('Pricing.POD') }}</el-radio>
          <el-radio label="pods">{{ $t('Pricing.PODs') }}</el-radio>
          <el-radio label="cod">{{ $t('Pricing.COD') }}</el-radio>
          <el-radio label="rod">{{ $t('Pricing.ROD') }}</el-radio>
          <el-radio label="podCityCode">{{ $t('Pricing.PODCity') }}</el-radio>
        </el-radio-group>
        <cargo-advance-select
          v-if="rdoGroupDes === 'pod'"
          filterable
          :placeholder="$t('Pricing.POLPrompt')"
          :select-type="selectTypeNames.basic_data_Seaport"
          style="width:190px;display: inline-block;margin-left: 10px;"
          :custom-label="(item)=>`[${item.code}]${item.englishName}`"
          :filter-tag-names="['code','englishName']"
          :show-custom-label-in-option="true"
          @parentCallBack="p=>{filter.pod=p.value}"
        />
        <cargo-pop-select-input
          v-if="rdoGroupDes === 'pods'"
          v-model="filter.pods"
          style="width:190px;display: inline-block;margin-left: 10px;"
          :column-defs="popSelectInputCols"
        />
        <cargo-advance-select
          v-if="rdoGroupDes === 'cod'"
          filterable
          :placeholder="$t('Pricing.COLPrompt')"
          :select-type="selectTypeNames.basic_data_Country"
          style="width:190px;display: inline-block;margin-left: 10px;"
          @parentCallBack="p=>{filter.cod=p.value}"
        />
        <cargo-advance-select
          v-if="rdoGroupDes === 'rod'"
          filterable
          :select-type="selectTypeNames.basic_data_Region"
          style="width:190px;display: inline-block;margin-left: 10px;"
          @parentCallBack="p=>{filter.rod=p.value}"
        />
        <cargo-advance-select
          v-if="rdoGroupDes === 'podCityCode'"
          :static-options="citySeaport"
          tag-name="name"
          tag-value="code"
          clearable
          filterable
          :filter-tag-names="['name', 'code']"
          style="width:190px;display: inline-block;margin-left: 10px;"
          :default-value="filter.podCityCode"
          @parentCallBack="p=>{filter.podCityCode=p.value}"
        />
        <el-form-item ref="hbCarrier" :label="$t('Pricing.Carrier')" style="margin-left: 10px;">
          <cargo-advance-select
            filterable
            :select-type="selectTypeNames.basic_data_Company"
            :method-params="{seaCmp:true}"
            :custom-label="(item)=>`[${item.shortName}]${item.chineseName}`"
            :show-custom-label-in-option="true"
            style="width:190px;"
            multiple
            :default-multiple-value="filter.carrier"
            @parentCallBack="p=>{filter.carrier=p.cmpIdx}"
          />
        </el-form-item>
        <el-form-item ref="hbSource" :label="$t('Pricing.Source')" style="margin-left: 10px;">
          <el-input v-model="filter.txtBookingAgent" style="width: 100px;" />
        </el-form-item>
        <el-form-item ref="hbFromTo" :label="$t('Pricing.BeginDate')" style="margin-left: 10px">
          <el-date-picker
            v-model="filter.beginDate"
            type="date"
            style="width:130px;margin-left:10px"
            value-format="yyyy-MM-dd"
          />
          <span style="margin: 5px;">{{ $t('Pricing.EndDate') }}</span>
          <el-date-picker
            v-model="filter.endDate"
            type="date"
            style="width:130px;"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item v-if="showLevel" ref="hbLevel" :label="$t('Pricing.Level')" style="margin-left: 10px;">
          <el-select
            v-model="filter.level"
            style="width:90px;display: inline-block;"
            @change="onLevelChanged"
          >
            <el-option
              v-for="(item,index) in tiers"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="isSurcharge" ref="hbUnNo" :label="$t('Pricing.UnNo')" style="margin-left: 10px;">
          <el-input v-model="filter.unNo" style="width: 85px;" />
        </el-form-item>
      </el-form>
      <el-form v-if="showSchedule" label-width="80px" label-position="left" :inline="true">
        <el-checkbox v-if="needAddon" v-model="filter.isAddon">Addon</el-checkbox>
        <el-checkbox v-model="filter.direct">{{ $t('Pricing.Direct') }}</el-checkbox>
        <el-checkbox v-model="filter.frequency1">{{ $t('Pricing.Mon') }}</el-checkbox>
        <el-checkbox v-model="filter.frequency2">{{ $t('Pricing.Tue') }}</el-checkbox>
        <el-checkbox v-model="filter.frequency3">{{ $t('Pricing.Wed') }}</el-checkbox>
        <el-checkbox v-model="filter.frequency4">{{ $t('Pricing.Thu') }}</el-checkbox>
        <el-checkbox v-model="filter.frequency5">{{ $t('Pricing.Fri') }}</el-checkbox>
        <el-checkbox v-model="filter.frequency6">{{ $t('Pricing.Sat') }}</el-checkbox>
        <el-checkbox v-model="filter.frequency7">{{ $t('Pricing.Sun') }}</el-checkbox>
      </el-form>
    </div>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import { PricingFCLConfigUtil } from '@/class/cargo/model/utils/PricingFCLConfigUtil'
import StrUtils from '@/utils/StrUtils'
import CargoPopSelectInput from '@/components/Cargo/Common/CargoPopSelectInput'
import DateUtils from '@/utils/dateUtils'

export default {
  name: 'FclSearchBar',
  components: {
    CargoPopSelectInput,
    searchItem, cargoAdvanceSelect, cargoOfficeSelect
  },
  props: {
    showAdv: { type: Boolean, default: true }, // 显示高级查询
    expandAdv: { type: Boolean, default: false }, // 是否初始展开高级查询
    disabled: { type: Boolean, default: false }, // 禁用
    showSimple: { type: Boolean, default: true }, // 显示简单UI查询
    isShowCreatedBy: { type: Boolean, default: false },
    isManageModule: { type: Boolean, default: false },
    isQueryPrice: { type: Boolean, default: false },
    isShowContractNo: { type: Boolean, default: false },
    isShowSaleState: { type: Boolean, default: false },
    showCurrency: { type: Boolean, default: false },
    showPriceNo: { type: Boolean, default: false },
    showLevel: { type: Boolean, default: undefined }, // 是否显示运价等级
    showSchedule: { type: Boolean, default: true }, // 是否显示船期
    isQuery: { type: Boolean, default: false }, // 是否是查询界面
    isSurcharge: { type: Boolean, default: false },
    filter: { type: Object, default: () => {
      return {}
    }
    }
  },
  data() {
    return {
      URL,
      selectTypeNames: TYPE_NAMES,
      tiers: [],
      rdoGroupOrg: 'pol',
      rdoGroupDes: 'pod',
      rowData: [],
      txtRemarks: '',
      remarkChange: false,
      needAddon: false,
      citySeaport: ColumnUtils.getCitySeaport(),
      simQueryPlaceholder: this.$t('Pricing.priceNoPrompt'), // 快捷检索 占位符
      isAdvancedQuery: false, // 是否为高级查询
      isShowingMoreSearchCondition: this.expandAdv,
      proxy: {},
      showDetail: false,
      keyWords: null,
      popSelectInputCols: [
        {
          colId: 'code',
          field: 'code',
          headerName: this.$t('Message.Code')
        }, {
          colId: 'chineseName',
          field: 'chineseName',
          headerName: this.$t('Message.ChineseName')
        }, {
          colId: 'englishName',
          field: 'englishName',
          headerName: this.$t('Message.EnglishName')
        }, {
          colId: 'countryCnName',
          field: 'countryCnName',
          headerName: this.$t('Message.Country')
        }, {
          colId: 'region',
          field: 'region',
          headerName: this.$t('Message.Region'),
          valueFormatter: (params) => {
            const { data } = params
            return this.$store.getters.language === 'zh' ? data.regionCnName : data.regionEnName
          }
        }
      ]
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.init()
      this.toQuery()
    },
    isShowingMoreSearchCondition(newVal) {
      this.$emit('advToggle', newVal)
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      const fclConfigUtil = await PricingFCLConfigUtil.getInstance()
      this.needAddon = fclConfigUtil._needAddon
      if (fclConfigUtil._needMarkup) {
        const showLevel = this.$checkPermission(['PFA']) || this.$checkPermission(['PFT'])
        this.showLevel = this.showLevel === undefined ? showLevel : this.showLevel
        this.tiers = PriceUtils.getTiers(fclConfigUtil._needMarkup, showLevel, this.getAuthedLevel())
      } else {
        this.tiers = PriceUtils.getTiers(false, false, 1)
      }
      this.filter.level = (this.tiers && this.tiers.length > 0) ? this.tiers[0].value : ''
      this.$nextTick(() => {
        this.setPosition()
      })
    },
    setPosition() {
      const { hbDetail, hbDetail2, hbCarrier, hbSource, hbLevel, hbCurrency, hbDangerous, hbSaleState, hbContractNo, hbUnNo } = this.$refs
      if (!this.isQuery) {
        if (this.showLevel) {
          hbDetail2.$el.appendChild(hbLevel.$el)
        }
        return
      }
      hbDetail.$el.appendChild(hbCarrier.$el)
      hbDetail.$el.appendChild(hbSource.$el)
      hbDetail.$el.appendChild(hbUnNo.$el)
      if (this.showLevel) {
        hbDetail2.$el.appendChild(hbLevel.$el)
      }
      if (this.showCurrency) {
        hbDetail2.$el.appendChild(hbCurrency.$el)
      }
      hbDetail2.$el.appendChild(hbDangerous.$el)
      if (this.isShowSaleState) {
        hbDetail2.$el.appendChild(hbSaleState.$el)
      }
      if (this.isShowContractNo) {
        hbDetail2.$el.appendChild(hbContractNo.$el)
      }
    },
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 查询
    toSimpleQuery() {
      this.proxy = {}
      this.proxy['isLimited'] = true
      this.proxy['level'] = 1
      this.proxy['isAdvanced'] = false
      this.proxy['tenantId'] = 0
      if (this.showPriceNo) {
        const keyWords = this.keyWords ? this.keyWords.trim() : ''
        if (!keyWords || keyWords.length === 0) {
          this.simQueryPlaceholder = ''
          this.$refs.keyword.focus()
          this.$message.warning(this.$t('Pricing.priceNoPrompt'))
          return
        }
        this.proxy['priceNo'] = keyWords
      } else {
        if (!this.filter.simPol) {
          this.$message.warning(this.$t('Pricing.POLIsNull'))
          this.$refs.simPol.$refs['advanceSelectRef'].$refs.reference.focus()
          return
        }
        if (!this.filter.simPod) {
          this.$message.warning(this.$t('Pricing.PODIsNull'))
          this.$refs.simPod.$refs['advanceSelectRef'].$refs.reference.focus()
          return
        }
        this.proxy['pol'] = this.filter.simPol
        this.proxy['pod'] = this.filter.simPod
        this.proxy['beginDate'] = DateUtils.formatStandardDate(new Date())
      }
      this.$emit('simSearchItemCallBack', this.proxy)
    },
    toAdvancedQuery() {
      this.proxy = {}
      this.proxy['isLimited'] = true
      this.proxy['isAdvanced'] = true
      this.proxy[this.rdoGroupOrg] = this.filter[this.rdoGroupOrg]
      this.proxy[this.rdoGroupDes] = this.filter[this.rdoGroupDes]
      this.setDateValue('createDateFrom', false)
      this.setDateValue('createDateTo', true)
      this.setDateValue('beginDate', false)
      this.setDateValue('endDate', true)
      if (this.showSchedule) {
        const FREQUENCYS = PriceUtils.FREQUENCYS
        const frequency = []
        for (const field of FREQUENCYS) {
          if (this.filter['frequency' + field]) {
            frequency.push('frequency' + field)
          }
        }
        frequency.join('/')
        this.proxy['frequencys'] = frequency
      }
      if (this.isManageModule || this.isShowCreatedBy) {
        if (this.filter.cmbCreatedBy === 'createdBy') {
          this.proxy['createdBy'] = this.filter.createdBy
        }
        if (this.filter.cmbCreatedBy === 'branch') {
          this.proxy['branchId'] = this.filter.branch
        }
      }
      if (this.filter.carrier.length > 0) {
        const scacs = this.getCompanyByScac(this.filter.carrier)
        if (scacs.length === 0 || !this.isQueryPrice) {
          this.proxy['carriers'] = this.filter.carrier.join(',')
        } else {
          this.proxy['carrierScac'] = scacs
        }
      }
      this.setBooleanValue('direct')
      this.setBooleanValue('isAddon')
      this.setBooleanValue('dangerous')
      this.setStrValue('unNo')
      this.setStrValue('txtBookingAgent')
      if (this.filter.saleState >= 0 && this.isShowSaleState) {
        this.proxy['saleState'] = this.filter.saleState
      }
      if (this.isShowContractNo && !StrUtils.isEmpty(this.filter.contractNo)) {
        this.proxy['contractNo'] = this.filter.contractNo
      }
      this.setIntValue('bAgentAutoComplete')
      this.setStrValue('chargeScaleCode')
      this.$emit('advSearchItemResetCallBack', this.proxy)
    },
    setStrValue(field) {
      if (!StrUtils.isEmpty(this.filter[field])) {
        this.proxy[field] = this.filter[field]
      }
    },
    setDateValue(field, isEnd) {
      if (!StrUtils.isEmpty(this.filter[field])) {
        this.proxy[field] = this.filter[field] + (isEnd ? ' 23:59:59' : '')
      }
    },
    setIntValue(field) {
      if (this.filter[field] > 0) {
        this.proxy[field] = this.filter[field]
      }
    },
    setBooleanValue(field) {
      if (this.proxy.hasOwnProperty(field)) {
        delete this.proxy[field]
      }
      if (this.filter[field]) {
        this.proxy[field] = this.filter[field]
      }
    },
    getAuthedLevel() {
      if (this.$checkPermission(['PFDA_*_0'])) {
        return 0
      } else if (this.$checkPermission(['PFDA_*_1'])) {
        return 1
      } else if (this.$checkPermission(['PFDA_*_2'])) {
        return 2
      }
      return 99
    },
    upOrDownSearchCondition() {
      this.isShowingMoreSearchCondition = !this.isShowingMoreSearchCondition
      this.isAdvancedQuery = this.isShowingMoreSearchCondition
      this.$emit('click-more', this.isShowingMoreSearchCondition)
      this.$emit('update:isSimpleQuery', !this.isShowingMoreSearchCondition)
    },
    keyWordBlur() {
      this.simQueryPlaceholder = this.$t('Pricing.priceNoPrompt')
    },
    resetSearch() {
      this.filter = PriceUtils.resetFilter(this.filter)
      this.filter.cmbCreatedBy = 'createdBy'
      this.filter.currency = 'USD'
      this.filter.level = '0'
      this.filter.saleState = -1
    },
    onLevelChanged() {
      const { showLevel } = this
      this.$emit('onLevelChanged', { showLevel, level: this.filter.level })
      this.$emit('onGridRefresh')
    },
    getCompanyByScac(value) {
      const companyStr = []
      for (const cmpIdx of value) {
        const scac = ColumnUtils.companyLabelFun(cmpIdx, 'scac', 'cmpIdx')
        if (!StrUtils.isEmpty(scac)) {
          companyStr.push(scac)
        }
      }
      return companyStr
    },
    changeCurrency(p) {
      this.filter.currency = p.value
      this.$emit('onGridRefresh')
    }
  }
}
</script>
<style lang="scss">
</style>

